import { Link } from "react-router-dom";

import { FaChevronRight } from "react-icons/fa6";

const CommonDashboardItem = ({ item }) => {
  return item?.route ? (
    <Link to={item?.route}>
      <div className="bg-white border-slate-300 border rounded-xl mt-2 flex flex-row justify-center items-center px-6 py-4">
        <img
          src={item?.image}
          className="w-12 h-12 object-contain"
          alt={item?.name ?? ""}
        />
        <h4 className="ml-4 font-medium text-base">{item?.name ?? ""}</h4>
        <div style={{ flex: 1 }} />
        <FaChevronRight fontSize={22} />
      </div>
    </Link>
  ) : (
    <button
      onClick={(e) => {
        e.preventDefault();
        if (item.action) item.action();
      }}
      className="bg-white border-slate-300 border rounded-xl mt-2 flex flex-row justify-center items-center px-6 py-4 w-full"
    >
      <img
        src={item?.image}
        className="w-12 h-12 object-contain"
        alt={item?.name ?? ""}
      />
      <h4 className="ml-4 font-medium text-base">{item?.name ?? ""}</h4>
      <div style={{ flex: 1 }} />
      <FaChevronRight fontSize={22} />
    </button>
  );
};

export default CommonDashboardItem;
